import React from 'react';

function App() {
  return (
    <main className="construction-shell">
      <section className="construction-card" aria-labelledby="construction-title">
        <img alt="SARAHAT" className="construction-logo" src={`${process.env.PUBLIC_URL}/New-refurbished-logo-green.png`} />
        <div className="construction-divider" />
        <p className="construction-kicker">Website under construction</p>
        <h1 id="construction-title">SARAHAT is getting ready.</h1>
        <p className="construction-copy">
          Our cloud consulting website is being prepared. For now, you can reach us directly by email.
        </p>
        <a className="construction-link" href="mailto:info@sarahat.com">info@sarahat.com</a>
      </section>
    </main>
  );
}

export default App;
